module.exports = __webpack_public_path__ + "static/img/235.2bb3863.png";